import { Link, useLocation } from 'react-router-dom';

import { useDuongDan } from '../../../hooks/useDuongDan';
import { useT } from '../../../i18n';
import { cn } from '../../../lib/cn';
import { CAU_BANG_CANH_BAO, LOP_BANG } from '../constants';
import { useDuocXemLicenseCucBo, useLicenseCucBo } from '../hooks/useLicenseCucBo';
import { canhBaoTheoTrangThai } from '../nghiep-vu/license-cuc-bo';

/** Đường dẫn gốc của màn license cục bộ (cổng tenant). */
export const DUONG_DAN_LICENSE_CUC_BO = '/he-thong/license';

/**
 * Băng cảnh báo license ở đầu mọi màn quản trị khi chạy bản on-premise
 * (ADR-0058 mục 6.3): `EXPIRING` vàng; `GRACE` đỏ kèm số ngày ân hạn còn lại;
 * `READ_ONLY`, `NOT_YET_VALID`, `INVALID` đỏ. `ACTIVE` không có băng.
 *
 * Chỉ quản trị viên bản cài thấy (`useDuocXemLicenseCucBo`). Không tải được
 * trạng thái thì không hiện gì: màn license tự nói lỗi, còn băng sai thì làm
 * người dùng hoảng ở mọi màn. Dính đầu `<main>` như `BangTamNgungToChuc`.
 */
export function BangCanhBaoLicense() {
  const { t } = useT();
  const duongDan = useDuongDan();
  const { pathname } = useLocation();
  const duocXem = useDuocXemLicenseCucBo();
  const { data } = useLicenseCucBo(duocXem);

  const canhBao = duocXem ? canhBaoTheoTrangThai(data) : null;
  if (!canhBao) return null;

  const denManLicense = duongDan(DUONG_DAN_LICENSE_CUC_BO);
  return (
    <div
      role={canhBao.muc === 'danger' ? 'alert' : 'status'}
      className={cn(
        'sticky top-0 z-10 flex flex-wrap items-center gap-x-3 gap-y-1 border-b px-6 py-3 text-sm',
        LOP_BANG[canhBao.muc],
      )}
    >
      <span className="min-w-0">{t(CAU_BANG_CANH_BAO[canhBao.trangThai], { so: canhBao.soNgay })}</span>
      {pathname !== denManLicense && (
        <Link to={denManLicense} className="font-medium underline underline-offset-2">
          {t('licenseCucBo.moManLicense')}
        </Link>
      )}
    </div>
  );
}
